import React from "react";
import { Box, Typography } from "@mui/material";

const MetalSymbol = ({ symbol, price }) => {
  // Format price only if it exists
  const formattedPrice = typeof price === 'number' ? price.toLocaleString() : '-';

  return (
    <Box
      sx={{
        backgroundColor: "#000",
        border: "2px solid #24e4ff",
        borderRadius: "8px",
        padding: { xs: "8px 12px", sm: "12px 20px", md: "15px 25px" },
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "3px",
        maxWidth: { xs: "80px", sm: "100px", md: "120px" },
        minWidth: { xs: "60px", sm: "80px", md: "100px" }
      }}
    >
      <Typography
        variant="h4"
        sx={{
          color: "#24e4ff",
          fontWeight: "bold",
          fontSize: { xs: "1.2rem", sm: "1.5rem", md: "2rem" }
        }}
      >
        {symbol}
      </Typography>
      <Typography
        variant="h5"
        sx={{
          color: "#24e4ff",
          fontSize: { xs: "0.8rem", sm: "1rem", md: "1.25rem" }
        }}
      >
        ${formattedPrice}
      </Typography>
    </Box>
  );
};

// Add prop type validation
MetalSymbol.defaultProps = {
  symbol: '',
  price: undefined
};

export default MetalSymbol;
